import axios from 'axios'
import { getToken } from '@/utils/auth'
import request from '@/utils/request'

/**
 * 上传图片
 * file 文件对象
 * @returns Promise
 */
export const uploadFile = async (file) => {
  try {
    const formData = new FormData()
    formData.append('file', file)
    const res = await axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + '/common/upload',
      headers: { Authorization: 'Bearer ' + getToken() },
      data: formData,
    })
    res.data.fileName = process.env.VUE_APP_BASE_URL + res.data.fileName
    return Promise.resolve(res.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 退出
export const logout = () => {
  return request({
    url: '/evaluate/user/logout',
    method: 'post',
  })
}

// 获取用户信息
export const getUserInfo = () => {
  return request({
    url: '/evaluate/usercenter/get-info',
    method: 'get',
  })
}

// 根据角色查询权限菜单
export const moduleRoleList = (params) => {
  return request({
    url: '/evaluate/menu/tree-by-role',
    method: 'get',
    params,
    headers: {
      // appCode: 'KTJXPJ',
      // isToken: false,
    },
  })
}

// 获取学校应用
export const schoolAppById = (id) => {
  return request({
    url: '/evaluate/school/getSchoolApplicationsById',
    method: 'get',
    params: { id },
  })
}
// 获取应用
export const myappList = (id) => {
  return request({
    url: '/evaluate/usercenter/get-myapp-list',
    method: 'get',
    params: { roleId: id },
  })
}


// 查询教师
export const teachersList = (params) => {

  return request({
    url: '/evaluate/teacher/list',
    method: 'get',
    params,
  })
}
// 查询年级班级
// export const gradelist = (params) => {
//   return request({
//     url: '/evaluate/grade/gradelist',
//     method: 'get',
//     params,
//   })
// }

export const gradelist = (params) => {
  return request({
    url: '/evaluate/grade/list',
    method: 'get',
    params,
  })
}
export const classesList = (params) => {
  return request({
    url: '/evaluate/classes/list',
    method: 'get',
    params,
  })
}




// 查询教学评价列表
export const classRoomAudioList = (params) => {

  return request({
    url: '/future/classRoomAudio/queryList',
    method: 'get',
    params,
  })
}

// 科目列表
export const subjectBySchoolId = (params) => {

  return request({
    url: 'evaluate/subject/getSubjectBySchoolId',
    method: 'get',
    params,
  })
}

export const classRoomAdd = (params) => {

  return request({
    url: '/future/classRoomAudio/saveAudio',
    method: 'post',
    data: params,
  })
}

// 查看报告
export const viewAudioReport = (id) => {
  return request({
    url: '/future/classRoomAudio/viewAudioReport',
    method: 'get',
    params: { id },
  })
}

/**
 *
 *局端
 *
 */
// 查询教学评价列表
export const bureauClassRooList = (params) => {

  return request({
    url: '/future/classRoomAudio/regionQueryList',
    method: 'get',
    params,
  })
}

// 科目列表
export const subjectSubject = (stage) => {
  return request({
    url: '/evaluate/subject/list',
    method: 'get',
    params: { stage },
  })
}

// 省市区
export const areaInfo = (parentId = 0) => {
  return request({
    url: '/evaluate/org/list',
    method: 'get',
    params: { parentId },
  })
}
